//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

import { Enums } from '../../../models/common/enums'
import { OpSchema } from '../../../models/custom'
import { IReferenceType, IAlarmConfigurable } from '../../../models/util/interfaces'

import { LocalDictionaryFactory } from '../../api/api.module'
import { SchemaModel, ColumnModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'

import { LoggerService } from '../../common/common.module'
import { CommonHelper } from '../../../helpers/common-helper'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { TemplateHelper, ConfigHelper, LogHelper, ConvertHelper, ToastHelper, DataTypeGroupComponent, ReferenceTypeComponent, Dictionary } from '../../../helpers'
import { UserSessionService } from '../../../services/user-session'
import { GridService } from '../../../services/grid'
import { MeterService } from '../../../services/meter'
import { CreateEditResult, SystemService } from '../../../services/system'
import { DeviceService } from '../../../services/device'

import { OperatorLayoutSettings } from './../../../helpers/operator-layout-settings'
import { MeasurementsBridge } from '../../common/measurements/measurements.controller'
import { GridBridge } from '../../common/common.interfaces'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { ConnectedObject } from '../../common/connected-object/connected-object.directive'
import { DetailsPopupOptions, DetailsOptions } from '../../common/details-popup/details-popup.directive'
import { GridOptions, GridTypes, GridController } from '../../common/grid'
import { TreeListOptions } from '../../common/tree-list'
import { ActionStatusOptions } from '../../common/action-status/action-status.controller'
import { ActionHelper } from '../../../helpers/action-helper'
import { Activity } from '../../../models/common/activity'
import { OpMeter, OpDataTypeInGroup, OpData, OpDevice, OpIssue, OpDataType } from '../../../models/core'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { SchemaService } from '../../../services/schema'
import { AlarmDefinitionsOptions, IAlarmDefinitions } from '../../common/alarm-definition/alarm-definitions'
import { IAlarmDefinitionsEditOptions } from '../../common/alarm-definition/alarm-definitions-edit'
import { HistorySource } from '../../common/history/history.directive.controller'
import { AlarmDefinitionsEditController } from '../../common/alarm-definition/alarm-definitions-edit/alarm-definitions-edit.directive.controller'
import { SourcePopover } from '../../common/select-box-popup'
import { GridEditController } from '../../common/grid-edit/grid-edit.controller'

interface MeterDetailsScope extends DetailsScope {
	METER_COMMON_TAB_NAME: string
	METER_MEASUREMENTS_TAB_NAME: string
	METER_HISTORY_TAB_NAME: string
	METER_PARAMS_ACCORDION_NAME: string
	METER_EXTENDED_PARAMS_ACCORDION_NAME: string
	METER_DEVICES_ACORDION_NAME: string
	METER_ALARM_DEFINITIONS_ACCORDION_NAME: string
	METER_ISSUES_TABLE_ACCORDION_NAME: string
	DELETE_CONFIRMATION_POPUP_ID: string

	METER_DEVICES_POPUP_ID: string
	METER_ALARM_DEFINITINS_POPUP_ID: string
	ACTION_STATUS_POPUP_ID: string

	noActiveAccordionsText: string

	id: number
	popupTitle: string
	detailsParametersOptions: DetailsParametersOptions
	connectedObject: ConnectedObject
	connectedObjectActions: DevExpress.ui.dxButtonOptions[]
	schemas: SchemaModel[]
	detailedParamGridOptions: TreeListOptions
	devicesGridOptions: GridOptions
	deviceBridge: GridBridge
	alarmDefinitionsOptions: AlarmDefinitionsOptions
	alarmDefinitionsEditOptions: {
		alarmDefinitionsOptions: IAlarmDefinitionsEditOptions
		onInitialized: (component: AlarmDefinitionsEditController) => void
	}
	measurementsBridge: MeasurementsBridge
	historySource: HistorySource
	deleteConfirmationOptions: {
		title: string
		onConfirmed: () => void
	}

	showMeterIssues: boolean
	meterIssuesGridOptions: GridOptions
}

export class MeterDetailsDirectiveController extends Details<MeterDetailsScope> {
	//#region Consts

	private static get LOG_STRING(): string {
		return '[SIMAX.Meter.Details.Controller] - %s'
	}
	private get METER_DEVICES_GRID_NAME(): string {
		return 'meterDevicesGrid'
	}
	private get METER_HISTORY_NAME(): string {
		return 'metersHistory'
	}
	private get MeterIssuesGridName(): string {
		return 'MeterDetailsIssues'
	}

	//#endregion Consts End

	//#region Members

	private referenceObject: OpMeter
	private referenceObjectId: number

	private meterDevicesGrid: GridController<OpDevice>

	private alarmDefinitionsComponent: IAlarmDefinitions

	private alarmDefinitionsEditController: AlarmDefinitionsEditController

	private meterDevicesGridEditComponent: GridEditController

	private meterIssues: OpIssue[]

	//#endregion

	//#region Ctro

	public constructor(
		protected $scope: MeterDetailsScope,
		protected $q: ng.IQService,
		protected logger: LoggerService,
		protected $timeout: ng.ITimeoutService,
		protected localDictionary: LocalDictionaryFactory,
		protected userSession: UserSessionService,
		private systemService: SystemService,
		private meterService: MeterService,
		private deviceService: DeviceService,
		private schemaService: SchemaService,
		private gridService: GridService,
		protected referenceType: Enums.ReferenceType,
		private moduleName: Enums.SimaxModuleName
	) {
		super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.MeterPopupTabActive, userSession, referenceType, moduleName)

		this.setTemplateConsts()
		this.setConfirmationsOptions()
		this.setEvents()
		this.setOptions()

		if (this.userSession.getLoggedOperator().hasPermission(Activity.METER_LIST)) {
			this.configureTabs(this.getTabs())
		}
	}

	//#endregion

	//#region Events

	private onConfirmDelete(): void {
		this.meterService
			.deleteMeter(this.referenceObjectId)
			.then(() => {
				this.onDeleted()
			})
			.fail((error: any) => {
				LogHelper.error(DeviceService.LOG_PREFIX, error)
			})
			.always(() => {
				this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
			})
	}

	private onDelete(): void {
		this.$scope.$broadcast(
			EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.DELETE_CONFIRMATION_POPUP_ID,
			LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
		)
	}

	private onDeleted(): void {
		super.markAsDeleted()

		this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
		this.hidePopup()
	}

	private onEdit(): void {
		this.meterService.openEditByMeter(this.referenceObject).then((result: CreateEditResult<OpMeter>) => {
			if (result.status === CreateEditResult.Status.Success) {
				this.onEdited(result.object)
			}
		})
	}

	private onEditExtendedParameters(): void {
		this.meterService.openExtendedParametersEditByMeter(this.referenceObject).then((result: CreateEditResult<OpMeter>) => {
			if (result.status === CreateEditResult.Status.Success) {
				this.onEdited(result.object)
			}
		})
	}

	private onEdited(meter: OpMeter): void {
		super.markAsEdited()

		this.onRefresh(meter)
	}

	private onRefresh(toRefresh: OpMeter = null): void {
		this.$scope.options.isDataLoaded = false
		const deferred: JQueryDeferred<OpMeter> = $.Deferred<OpMeter>()

		if (toRefresh == null) {
			this.meterService
				.getMeter(this.referenceObjectId)
				.then((result: OpMeter) => {
					this.$scope.popupTitle = result.toString()
					deferred.resolve(result)
				})
				.fail((error: any) => {
					const errorMsg: string = ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator)
					ToastHelper.showError(errorMsg)
					LogHelper.error(DeviceService.LOG_PREFIX, errorMsg)

					deferred.resolve(null)
				})
				.always(() => {
					this.$scope.showTabs = true
				})
		} else {
			deferred.resolve(toRefresh)
		}

		deferred
			.promise()
			.then((result: OpMeter) => {
				if (result && (!this.referenceObject || this.referenceObject.idMeter == result.idMeter)) {
					this.referenceObject = result

					return $.when(
						this.setMeterIssuesGridOptions(),
						this.setBasicParameters(),
						this.setExtendedParameters(),
						this.setDevicesGridOptions(),
						this.setConnectedObjectOptions(),
						this.setMeterAlarmDefOptions(),
						this.setMeterAlarmDefinitionsEditOptions(),
						this.setMeasurementOptions(),
						this.initializeDeviceGridEdit(result.currentDevices)
					)
				}
			})
			.then(() => {
				return this.setSchemas()
			})
			.always(() => {
				this.$scope.options.isDataLoaded = true
			})
	}

	private onClear(): void {
		this.$scope.popupTitle = ''
		this.$scope.showTabs = false
		this.$scope.schemas = null
		this.$scope.devicesGridOptions = null
		this.$scope.measurementsBridge = null
		this.$scope.deviceBridge = null
		this.$scope.historySource = null
		this.$scope.connectedObject = null

		this.referenceObject = null
		this.alarmDefinitionsComponent = null
	}

	protected onInitialize(options: DetailsOptions): void {
		this.$scope.detailsOpenParams = options
		this.$scope.popupFor = CommonHelper.meter

		this.referenceObjectId = options.referenceObjectId

		this.onClear()
		this.onRefresh()
		this.setHistoryOptions()
		this.showPopup()
	}

	private onExtendedParameterCellPrepared(options: any): void {
		if (options != null && options.rowType == 'data' && options.column.dataField == 'value' && options.data) {
			if (options.data instanceof OpData) {
				const data: OpData = options.data

				if (data.dataType == null) {
					data.dataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(data.idDataType)
				}

				if (data.value != null) {
					if (data.dataType != null && data.dataType.idReferenceType != null) {
						options.cellElement.html('<div class="grid-cell-loader"></div>')
						this.meterService
							.getReferenceObject(data.dataType.idReferenceType, data.value)
							.then((referenceObject: IReferenceType) => {
								return options.cellElement.html(referenceObject == null ? null : referenceObject.toString())
							})
							.catch(() => {
								options.cellElement.html(data.value)
							})
					} else {
						options.cellElement.html(ConvertHelper.prepareDataValue(data.value, data.dataType))
					}
				}
			} else if (options.data.rows != null) {
				this.$q
					.all(
						options.data.rows.map((row: OpData) => {
							if (row != null) {
								if (row.value != null) {
									if (row.dataType != null && row.dataType.idReferenceType != null) {
										options.cellElement.html('<div class="grid-cell-loader"></div>')
										return this.meterService
											.getReferenceObject(row.dataType.idReferenceType, row.value)
											.then((referenceObject: IReferenceType) => {
												return referenceObject == null ? null : referenceObject.toString()
											})
											.catch(() => {
												options.cellElement.html(row.value)
											})
									} else {
										return ConvertHelper.prepareDataValue(row.value, row.dataType)
									}
								}
							}

							return null
						})
					)
					.then((values: any[]) => {
						if (_.size(values) > 0) {
							values = _.filter(values, (val: any) => val != null)
							options.cellElement.html(values.join(';'))
						}
					})
			}
		}
	}

	private onSaveMeterDevices(added: { id: number;[key: string]: any }[], removed: { id: number;[key: string]: any }[]): ng.IPromise<boolean> {
		const deferred = this.$q.defer<boolean>()

		if (_.size(added) === 0 && _.size(removed) === 0) {
			deferred.resolve(false)
			this.onRefresh()
		} else {
			const promise: JQueryDeferred<void> = $.Deferred<void>()
			let idDepository: number = null

			if (_.size(removed) > 0) {
				if (this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_LIST)) {
					const selectDepositoryOptions: SourcePopover = {
						popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectDepositoryToAssign),
						selectPopoverSource: {
							dataTypeId: Enums.DataType.DEPOSITORY_ID,
							referenceTypeId: Enums.ReferenceType.IdLocation,
							selectedId: idDepository,
							dataIdSourceModule: Enums.WebSimaxModule.Depositories,
						},
						nothingSelectedMsg: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NothingSelected),
						allowEmptyValueSubmit: false,

						onSubmit: (idLocationToSave: number) => {
							idDepository = idLocationToSave
							this.meterDevicesGridEditComponent.setIsLoading(true)
							promise.resolve()
						},
						onHiding: () => {
							promise.reject()
						},
					}

					this.$scope.$broadcast(EventsNames.OPEN_SELECT_POPOVER_POPUP + this.$scope.selectBoxPopupId, selectDepositoryOptions)
				} else if (this.userSession.getLoggedOperator().idDepositoryLocation > 0) {
					idDepository = this.userSession.getLoggedOperator().idDepositoryLocation
					promise.resolve()
				} else {
					ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.OperatorWithoutPermissionAndDepository))
					promise.reject()
				}
			} else {
				this.meterDevicesGridEditComponent.setIsLoading(true)
				promise.resolve()
			}

			$.when(promise)
				.then(() => {
					this.meterService
						.saveMeterDevices(this.referenceObject, added, removed, idDepository)
						.then((savedObject: OpMeter) => {
							this.onRefresh(savedObject)

							deferred.resolve(true)
						})
						.fail((error: any) => {
							this.logger.log(error)

							deferred.resolve(false)
						})
						.always(() => {
							this.meterDevicesGridEditComponent.setIsLoading(false)
						})
				})
				.fail(() => {
					deferred.reject()
				})
		}

		return deferred.promise
	}

	private onMeterDevicesClosed(): void {
		this.meterDevicesGrid.dxGrid.refresh()
	}

	private onUpdateMeters(args: any[]): void {
		if (_.size(args) > 0) {
			const opMeter: OpMeter = args[0]
			if (opMeter != null && opMeter.idMeter === this.referenceObject.idMeter) {
				this.onRefresh(opMeter)
			}
		}
	}

	private onMeterIssuessDoubleClick(args: any, issues: OpIssue[]): void {
		this.systemService.openDetails(<
			DetailsOptions //TODO replace it to issueService when it created
			>{
				moduleName: Enums.SimaxModuleName.Issue,
				pageItemsIds: issues.map((issue: OpIssue) => issue.idIssue),
				referenceObjectId: args.data[CommonHelper.idField],
			})
	}

	//#endregion

	//#region Setup

	public getAccordions(): DetailsAccordion[] {
		const accordions: DetailsAccordion[] = []

		if (
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterParameters) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterExtendedParameters)
		) {
			const items: DetailsAccordionSection[] = []

			if (!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterParameters)) {
				items.push({
					name: this.$scope.METER_PARAMS_ACCORDION_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BasicParameters),
					showInTab: this.$scope.METER_COMMON_TAB_NAME,
					visible: true,
					showStatus: false,
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.METER_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterParameters),

					editMethod: (): void => {
						this.onEdit()
					},
				})
			}

			if (!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterExtendedParameters)) {
				items.push({
					name: this.$scope.METER_EXTENDED_PARAMS_ACCORDION_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SpecificParameters),
					showInTab: this.$scope.METER_COMMON_TAB_NAME,
					visible: true,
					showStatus: false,
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.METER_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterExtendedParameters),

					editMethod: (): void => {
						this.onEditExtendedParameters()
					},
				})
			}

			accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.MeterDetailsAccordions, 0, items))
		}

		const hasMeterDevicesViewPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterDevices)
		const hasIssuesViewPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterIssues, true)

		if (hasMeterDevicesViewPermission || hasIssuesViewPermission) {
			const items: DetailsAccordionSection[] = []

			if (hasMeterDevicesViewPermission) {
				items.push({
					name: this.$scope.METER_DEVICES_ACORDION_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Devices),
					showInTab: this.$scope.METER_COMMON_TAB_NAME,
					visible: true,
					showStatus: true,
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.METER_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterDevices),
					editMethod: (): void => {
						if (this.meterDevicesGridEditComponent != null) {
							this.meterDevicesGridEditComponent.setIsLoading(false)
						}

						this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.$scope.METER_DEVICES_POPUP_ID, 'meterDevices')
					},
					status: (): string => {
						return this.getMeterDEvicesAccordionStatus()
					},
				})
			}

			if (hasIssuesViewPermission) {
				items.push({
					canEdit: false,

					name: this.$scope.METER_ISSUES_TABLE_ACCORDION_NAME,
					showInTab: this.$scope.METER_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Issues),

					showStatus: true,
					visible: true,

					status: () => `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssuesCount)} ${_.size(this.meterIssues)}`,
				})
			}

			accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.MeterDetailsAccordions, 1, items))
		}

		if (!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterAlarmDef)) {
			const items: DetailsAccordionSection[] = []

			if (!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterAlarmDef)) {
				items.push({
					name: this.$scope.METER_ALARM_DEFINITIONS_ACCORDION_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefs),
					showInTab: this.$scope.METER_COMMON_TAB_NAME,
					visible: true,
					showStatus: true,
					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.METER_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterAlarmDef),
					editMethod: (): void => {
						this.onLocationAlarmDefEdit()
					},
					status: (): string => {
						return this.getMeterAlarmDefAccordionStatus()
					},
				})
			}

			accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.MeterDetailsAccordions, 2, items))
		}

		return accordions
	}

	private setOptions(): void {
		this.$scope.options = <DetailsPopupOptions>{
			id: this.$scope.id,
			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

			actions: this.getActions(),

			openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
			closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),

			delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.METER_DEL) ? Activity[Activity.METER_DEL] : null,

			deleteMethod: () => this.onDelete(),
			getAccordionDataMethod: () => {
				return this.getAccordionData()
			},
			getAccordionSelectionMethod: () => {
				return this.getAccordionSelection()
			},
			updateAccordionMethod: (names: any[]) => {
				return this.updateAccordions(names)
			},
		}
	}

	private setBasicParameters(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()
		this.$scope.detailsParametersOptions = null

		DataTypeGroupComponent.getDataTypeInGroupByModule(
			this.userSession.getDataProvider(),
			Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY,
			this.moduleName,
			Enums.ReferenceType.IdMeterType,
			this.referenceObject.idMeterType
		).then((dataTypeInGroup: OpDataTypeInGroup[]) => {
			this.$scope.detailsParametersOptions = {
				dataTypes: dataTypeInGroup,
				referenceType: this.referenceType,
				referenceObject: this.referenceObject,
				useDynamicValues: true,
				onDataLoaded: () => {
					def.resolve()
				}
			}
		})
			.catch(() => {
				def.reject()
			})

		if (this.isAccordionHidden(this.$scope.METER_PARAMS_ACCORDION_NAME)) {
			def.resolve()
		}

		return def.promise()
	}

	private setExtendedParameters(): JQueryPromise<void> {
		this.$scope.detailedParamGridOptions = null

		return $.when(
			DataTypeGroupComponent.getDataTypeInGroupByModule(
				this.userSession.getDataProvider(),
				Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_DISPLAY,
				this.moduleName,
				Enums.ReferenceType.IdMeterTypeClass,
				this.referenceObject.meterType.idMeterTypeClass
			)
		).then((toDisplay: OpDataTypeInGroup[]) => {
			this.$scope.detailedParamGridOptions = this.meterService.getExtendedParametersOptions(true)
			this.$scope.detailedParamGridOptions.onCellPrepared = (options: any): void => {
				this.onExtendedParameterCellPrepared(options)
			}

			if (toDisplay == null) {
				toDisplay = []
			}

			const idDataTypes: number[] = toDisplay.map((dtig: OpDataTypeInGroup) => dtig.idDataType)

			this.$scope.detailedParamGridOptions.dataSource = this.meterService.createDataSourceForExtendedParameters(this.referenceObject, idDataTypes)
		})
	}

	private setDevicesGridOptions(): JQueryPromise<void> {
		this.$scope.devicesGridOptions = null

		return $.when(this.userSession.getDataProvider().System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEVICE_GRID_PARAMS, this.moduleName)).then(
			(columns: ColumnModel[]) => {
				this.$timeout(() => {
					this.$scope.devicesGridOptions = {
						name: 'MeterDetailsDevices',
						type: GridTypes.NO_SEARCH_BAR_SMALL,
						buttonsOptions: {
							enabled: false,
						},
						columnsDictionary: columns,
						dataSource: this.referenceObject.currentDevices,
						addCustomFilters: true,
						allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.MeterDevices),
						onInitialized: (e: any, grid: GridController<OpDevice>) => (this.meterDevicesGrid = grid),
						onRowDoubleClick: (e: any) => {
							if (this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)) {
								this.systemService.openDetails(this.deviceService.getDetailsOptions(e.data[CommonHelper.idField]))
							}
						},
					}
				})
			}
		)
	}

	private setMeterIssuesGridOptions(): JQueryPromise<void> {
		this.$scope.meterIssuesGridOptions = null
		this.$scope.showMeterIssues = false

		const deferred: JQueryDeferred<OpIssue[]> = $.Deferred<OpIssue[]>()

		if (this.referenceObject != null && this.referenceObject.idMeter > 0) {
			this.meterService.getMeterIssues(this.referenceObject.idMeter).then((issues: OpIssue[]) => {
				deferred.resolve(issues)
			})
		} else {
			deferred.resolve([])
		}

		return deferred.promise().then((issues: OpIssue[]) => {
			this.$scope.showMeterIssues = true
			this.meterIssues = issues

			this.$scope.meterIssuesGridOptions = {
				name: this.MeterIssuesGridName,
				type: GridTypes.PAGINATED_SMALL,
				addCustomFilters: true,
				columnsDictionary: this.meterService.getMeterIssuesGridColumns(),
				dataSource: issues,

				buttonsOptions: {
					enabled: false,
				},

				allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.LocationIssues),

				onRowDoubleClick: (args: any) => {
					this.onMeterIssuessDoubleClick(args, issues)
				},
			}
		})
	}

	private setConfirmationsOptions(): void {
		this.$scope.deleteConfirmationOptions = {
			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
			onConfirmed: () => this.onConfirmDelete(),
		}
	}

	private initializeDeviceGridEdit(devices: OpDevice[]): JQueryPromise<void> {
		return this.userSession
			.getDataProvider()
			.System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEVICE_GRID_PARAMS, this.moduleName, { viewReferenceType: Enums.ReferenceType.SerialNbr })
			.then((columns: ColumnModel[]) => {
				this.setMeterDevicesGridEditOptions(devices, columns)
			})
	}

	private setEvents(): void {
		this.$scope.$on(EventsNames.UPDATE_SCHEMAS, (event: ng.IAngularEvent, ...args: any[]) => this.setSchemas())

		this.$scope.$on(EventsNames.SEND_CONFIGURATION_TO_DEVICE, (event: ng.IAngularEvent, ...args: any[]) => this.sendDeviceConfiguration())

		this.$scope.$on(EventsNames.CLOSE_GRID_EDIT_POPUP + this.$scope.METER_DEVICES_POPUP_ID, (event: ng.IAngularEvent, ...args: any[]) => this.onMeterDevicesClosed())

		this.$scope.$on(EventsNames.UPDATE_METERS, (event: ng.IAngularEvent, ...args: any[]) => this.onUpdateMeters(args))
	}

	private setConnectedObjectOptions(): void {
		this.$scope.connectedObject = {
			connectedObjectMethod: 'device',

			connectedObjectTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CurrentDevice),
			connectedObjectVisibility: _.size(this.referenceObject.currentDevices) > 0,

			connectedObjectId: this.referenceObject.currentDevice != null ? this.referenceObject.currentDevice.serialNbr : null,

			connectedObjectName: this.referenceObject.currentDevice != null ? this.referenceObject.currentDevice.toString() : null,

			connectedObjectAllowLink: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_LIST),
		}
	}

	private setSchemas(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()
		this.$scope.schemas = []

		if (!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterGeneralSchema)) {
			this.userSession
				.getDataProvider()
				.System.getSchema(this.referenceType, [this.referenceObjectId])
				.then((schemas: OpSchema[]) => {
					if (_.size(schemas) > 0) {
						schemas = this.schemaService.limitSchemaCount(schemas)

						const simpleXmlSchemas: SchemaModel[] = schemas
							.filter((schema: OpSchema) => {
								return schema.class === Enums.LocationSchemaClass.SimpleXml
							})
							.map((schema: OpSchema) => {
								return CommonHelper.opSchemaToSchemaModel(schema, this.userSession)
							})

						if (simpleXmlSchemas.length > 0) {
							this.$scope.schemas = simpleXmlSchemas
						}
					}

					return schemas
				})
				.fail((error: any) => {
					const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

					ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
					LogHelper.warn(DeviceService.LOG_PREFIX, 'Unable to load schema.')
				})
				.always(() => {
					def.resolve()
				})
		} else {
			def.resolve()
		}

		return def.promise()
	}

	private setTemplateConsts(): void {
		this.$scope.METER_COMMON_TAB_NAME = 'METER_COMMON_TAB_NAME'
		this.$scope.METER_MEASUREMENTS_TAB_NAME = 'METER_MEASUREMENTS_TAB_NAME'
		this.$scope.METER_HISTORY_TAB_NAME = 'METER_HISTORY_TAB_NAME'

		this.$scope.METER_PARAMS_ACCORDION_NAME = 'METER_PARAMS_ACCORDION_NAME'
		this.$scope.METER_EXTENDED_PARAMS_ACCORDION_NAME = 'METER_EXTENDED_PARAMS_ACCORDION_NAME'
		this.$scope.METER_DEVICES_ACORDION_NAME = 'METER_DEVICES_ACORDION_NAME'
		this.$scope.METER_ALARM_DEFINITIONS_ACCORDION_NAME = 'METER_ALARM_DEFINITIONS_ACCORDION_NAME'
		this.$scope.METER_ISSUES_TABLE_ACCORDION_NAME = 'METER_ISSUES_TABLE_ACCORDION_NAME'

		this.$scope.DELETE_CONFIRMATION_POPUP_ID = this.$scope.detailsPopupId + '_DELETE_CONFIRMATION_POPUP'
		this.$scope.METER_DEVICES_POPUP_ID = this.$scope.detailsPopupId + '_METER_DEVICES_POPUP'
		this.$scope.METER_ALARM_DEFINITINS_POPUP_ID = this.$scope.detailsPopupId + '_METER_ALARM_DEFINITINS_POPUP'
		this.$scope.ACTION_STATUS_POPUP_ID = this.$scope.detailsPopupId + '_ACTION_STATUS_POPUP'

		this.$scope.noActiveAccordionsText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoActiveAccordions)

		this.$scope.selectBoxPopupId = new Date().getTime()
	}

	public getTabs(addSchemaTab: boolean = false): { template: string; name: string }[] {
		const tabs: { template: string; name: string }[] = []

		if (
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterParameters) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterExtendedParameters) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterDevices) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterAlarmDef) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterGeneralSchema && addSchemaTab)
		) {
			tabs.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),
				name: this.$scope.METER_COMMON_TAB_NAME,
			})
		}

		if (
			this.userSession.getLoggedOperator().hasPermission(Activity.MEASUREMENTS_LIST) &&
			!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterMeasurements)
		) {
			tabs.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Measurements), ConfigHelper.Icon.MEASUREMENTS, this.userSession),
				name: this.$scope.METER_MEASUREMENTS_TAB_NAME,
			})
		}

		if (!this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterHistory)) {
			tabs.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.History), ConfigHelper.Icon.HISTORY, this.userSession),
				name: this.$scope.METER_HISTORY_TAB_NAME,
			})
		}

		return tabs
	}

	private setMeterAlarmDefOptions(): void {
		this.$scope.alarmDefinitionsOptions = {
			isColumnReorderAllowed: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.MeterAlarmDef),

			referenceType: Enums.ReferenceType.IdMeter,
			referenceObjectId: this.$scope.modelId,

			onInitialized: (component: IAlarmDefinitions) => {
				this.onAlarmDefinitionsInitialized(component)
			},
		}
	}

	private setMeterAlarmDefinitionsEditOptions(): void {
		this.$scope.alarmDefinitionsEditOptions = {
			alarmDefinitionsOptions: {
				configurationReferenceObject: this.referenceObject.currentDevice,
				moduleName: this.moduleName,
				referenceType: this.referenceType,
				referenceObject: this.referenceObject,
				sendConfigurationIdActivity: Activity.DEVICE_CONFIGURATION_SEND,

				sendConfiguration: () => {
					this.sendDeviceConfiguration()

					return $.Deferred<any>().resolve().promise()
				},

				onAlarmConfigurableSaved: (alarmConfigurable: IAlarmConfigurable) => {
					this.$scope.alarmDefinitionsEditOptions.alarmDefinitionsOptions.referenceObject = alarmConfigurable

					return this.onAlarmConfigurableSaved(alarmConfigurable)
				},
			},
			onInitialized: (component: AlarmDefinitionsEditController) => {
				this.alarmDefinitionsEditController = component
			},
		}
	}

	private setMeterDevicesGridEditOptions(devices: OpDevice[], columns: ColumnModel[]): void {
		this.$scope.deviceBridge = {
			columns,
			id: this.referenceObjectId,
			items: devices.map((device: OpDevice) => this.gridService.gridObjectFromIOpObject(device)),
			name: this.METER_DEVICES_GRID_NAME,
			popupId: this.$scope.METER_DEVICES_POPUP_ID,
			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DEVICES_EDIT, this.moduleName),
			isLoadingIndicatorDisabled: true,
			onControllerInitialized: (component: GridEditController) => {
				this.meterDevicesGridEditComponent = component
			},

			allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.MeterSerialNbr),

			getAvailableDataSourceMethod: this.userSession.getDataProvider().Device.getDeviceFilter,

			onSubmit: (added: any[], removed: any[]) => this.onSaveMeterDevices(added, removed),
		}
	}

	private setMeasurementOptions(): void {
		if (this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterMeasurements)) {
			return
		}

		const meters: { id: number; name: string; referenceId: number }[] = []

		meters.push({
			id: this.referenceObjectId,
			name: this.referenceObject.toString(),
			referenceId: this.referenceObject.meterType.idMeterTypeClass,
		})

		this.$scope.measurementsBridge = {
			id: this.referenceObjectId,
			referenceType: this.referenceType,
			requestProperty: 'meterIds',

			meters: meters,

			allowColumnReordering: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.MeterMeasurements),

			hideChartOptions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_CHART_OPTION_HIDDEN, Enums.UIObjectProperties.MeterMeasurements),

			hideDataTypePanel: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MEASUREMENT_DATA_TYPE_OPTION_HIDDEN, Enums.UIObjectProperties.MeterMeasurements),

			chartOptionsPermissions: null, // TODO: To delete in future
			chartDataTypeOptionsPermissions: null, // TODO: To delete in future
			latestDataMethodName: null, // TODO: To delete in future
			dataMethodName: null, // TODO: To delete in future
		}
	}

	private setHistoryOptions(): void {
		this.$scope.historySource = {
			dataMethodName: null, // TODO: To delete in future
			id: null, // TODO: To delete in future

			name: this.METER_HISTORY_NAME,
			referenceType: this.referenceType,
			referenceValue: this.referenceObjectId,

			allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.MeterHistory),

			onRowDoubleClick: null,
		}
	}

	private getActions(): DevExpress.ui.dxButtonOptions[] {
		const actions: DevExpress.ui.dxButtonOptions[] = []

		if (this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_CONFIGURATION_SEND)) {
			actions.push({
				template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice), ConfigHelper.Icon.DEVICES, this.userSession),
				onClick: (e: any) => {
					this.sendDeviceConfiguration()
				},
				hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice),
				width: '100%',
				bindingOptions: {
					disabled: '!connectedObject.connectedObjectVisibility',
				},
			})

			this.$scope.connectedObjectActions = [
				{
					template: TemplateHelper.getIcon(ConfigHelper.Icon.DEVICES, this.userSession),
					onClick: (e: any) => {
						this.sendDeviceConfiguration()
					},
					hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice),
				},
			]
		}

		return actions
	}

	private sendDeviceConfiguration(): void {
		ActionHelper.sendDeviceConfiguration(this.userSession.getDataProvider(), [this.$scope.connectedObject.connectedObjectId], [this.$scope.popupTitle]).then(
			(actionStatusOptions: ActionStatusOptions) => {
				this.$scope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.$scope.detailsPopupId, actionStatusOptions)
			}
		)
	}

	//#endregion

	//#region AlarmDefinitions

	private onAlarmDefinitionsInitialized(component: IAlarmDefinitions): void {
		this.alarmDefinitionsComponent = component
	}

	private getMeterAlarmDefAccordionStatus(): string {
		const alarmDefCount: number = this.alarmDefinitionsComponent == null ? 0 : this.alarmDefinitionsComponent.getCurrentAlarmDefs().length
		return `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DefinedCount)}${alarmDefCount}`
	}

	private getMeterDEvicesAccordionStatus(): string {
		return (
			LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledCount) +
			(this.referenceObject != null && this.referenceObject.currentDevices != null && this.referenceObject.currentDevices.length ? this.referenceObject.currentDevices.length : 0)
		)
	}

	private onLocationAlarmDefEdit(): void {
		const hasEditPermission: boolean = this.userSession.getLoggedOperator().hasPermission(Activity.METER_EDIT)
		const notReadonlyPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.METER_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterAlarmDef)

		if (hasEditPermission && notReadonlyPermission && this.alarmDefinitionsEditController != null) {
			this.alarmDefinitionsEditController.showSingleEdit()
		} else {
			LogHelper.log(
				MeterDetailsDirectiveController.LOG_STRING,
				`onMeterAlarmDefEdit: hasEditPermission: ${hasEditPermission}, notReadonlyPermission: ${notReadonlyPermission}, alarmDefinitionEdit: ${this.alarmDefinitionsComponent == null ? '<null>' : 'Exists'
				}`
			)
		}
	}

	private onAlarmConfigurableSaved(alarmConfigurable: IAlarmConfigurable): void {
		if (alarmConfigurable == null) {
			return null
		}

		this.alarmDefinitionsComponent.setDataSource(alarmConfigurable.currentAlarmDefs)
	}

	//#endregion
}
